let $elements = $('.js-bitrix-show-panel-compensate');

updatePosition();
addHandlers();

function addHandlers() {
	
	$('#bx-panel-hider, #bx-panel-expander').click(function(){
		updatePosition();
	});
	
}

function updatePosition() {
	
	let height = $('#bx-panel').height();
	$elements.css('top', height+'px');
	
}	